import { Anchor, Stack, Text, useMantineTheme } from '@mantine/core';
import { Dropzone, DropzoneProps } from '@mantine/dropzone';
import React from 'react';

import { ReactComponent as Export4 } from '@portals/icons/linear/export-4.svg';

interface UploadDropzoneProps {
  dropzoneProps: Omit<DropzoneProps, 'children' | 'loading' | 'onDrop'>;
  onDrop: DropzoneProps['onDrop'];
}

export function UploadDropzone({ dropzoneProps, onDrop }: UploadDropzoneProps) {
  const theme = useMantineTheme();

  return (
    <Dropzone
      onDrop={onDrop}
      multiple={false}
      data-testid="upload-dropzone"
      styles={dropzoneStyles}
      {...dropzoneProps}
    >
      <Stack
        spacing="xs"
        align="center"
        justify="center"
        sx={{ height: '100%' }}
      >
        <Export4 width={40} height={40} color={theme.colors.blue_gray[2]} />

        <Text size="sm" mt="xs" sx={{ color: theme.colors.blue_gray[4] }}>
          Drag & drop files here
        </Text>

        <Text size="xs" inline sx={{ color: theme.colors.blue_gray[2] }}>
          or
        </Text>

        <Anchor size="sm">Upload from computer</Anchor>
      </Stack>
    </Dropzone>
  );
}

const dropzoneStyles: DropzoneProps['styles'] = () => ({
  inner: {
    height: '100%',
  },
});
